import React, { useState } from "react";
import axios from "axios";
import CurrentWeather from "./CurrentWeather";
import Forecast from "./Forecast.js";

export default function Weather(props) {
  const [city, setCity] = useState(props.defaultCity);
  const [searchedCity, setSearchedCity] = useState(props.defaultCity);
  const [weather, setWeather] = useState(null);
  const [unit, setUnit] = useState("celsius");

  function handleCityInput(event) {
    setCity(event.target.value);
  }

  function handleSubmit(event) {
    event.preventDefault();
    setSearchedCity(city);
    search(city);
  }

  function search(cityName) {
    const apiKey = "40o03736bbe0e6faa9b79f5dt4af0a0f";
    const apiUrl = `https://api.shecodes.io/weather/v1/current?query=${cityName}&key=${apiKey}&units=metric`;
    axios.get(apiUrl).then(displayWeather);
  }

  function displayWeather(response) {
    const latitude = response.data.coordinates.latitude;
    const longitude = response.data.coordinates.longitude;

    const timezoneApiKey = "KWPVZGTIJD92";
    const timezoneApiUrl = `https://api.timezonedb.com/v2.1/get-time-zone?key=${timezoneApiKey}&format=json&by=position&lat=${latitude}&lng=${longitude}`;
    axios
      .get(timezoneApiUrl)
      .then((getTimezone) => {
        updateWeather(response, getTimezone.data.zoneName);
      })
      .catch(() => {
        updateWeather(response, null);
      });
  }

  function updateWeather(response, timezone) {
    const data = response.data;
    setWeather({
      city: data.city,
      time: new Date(data.time * 1000),
      timezone: timezone,
      temperature: data.temperature.current,
      description: data.condition.description,
      humidity: data.temperature.humidity,
      wind: data.wind.speed,
      icon: data.condition.icon_url,
    });
  }

  function getWeatherInfo() {
    if (weather) {
      return <CurrentWeather weather={weather} unit={unit} setUnit={setUnit} />;
    } else {
      return null;
    }
  }

  if (weather === null) {
    search(props.defaultCity);
  }

  return (
    <div className="weather">
      <header>
        <form className="search-bar" onSubmit={handleSubmit}>
          <input
            type="search"
            placeholder="Enter a city..."
            className="search-input"
            autoFocus
            onChange={handleCityInput}
          />
          <input type="submit" value="⟶" className="submit-button" />
        </form>
      </header>
      {getWeatherInfo()}
      <Forecast city={searchedCity} unit={unit} setUnit={setUnit} />
    </div>
  );
}
